import React from "react";
import { Alert, List, QRCode, Typography, Image, Divider } from 'antd';
import { Table } from "react-bootstrap";
import Moment from 'react-moment';
import Common from "./includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var OrderReceipt = function OrderReceipt(_ref) {
  var bill = _ref.bill,
    _ref$settlement = _ref.settlement,
    settlement = _ref$settlement === void 0 ? null : _ref$settlement;
  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: bill && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: '130px',
          textAlign: 'center !important'
        },
        children: /*#__PURE__*/_jsx(Image, {
          preview: false,
          width: "100%",
          src: Common.baseUrl + Common.businessAccount.logo,
          fallback: "/drawables/ss.png"
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx("b", {
          children: "Date:"
        }), " ", /*#__PURE__*/_jsx(Moment, {
          format: "DD/MM/YYYY H:m"
        })]
      }), /*#__PURE__*/_jsxs("h3", {
        children: ["CLIENT : ", bill.company.label]
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h4", {
        children: "D\xE9tails commande"
      }), /*#__PURE__*/_jsxs(Table, {
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "Produits"
            }), /*#__PURE__*/_jsx("th", {
              children: "Qte"
            }), /*#__PURE__*/_jsx("th", {
              children: "P.Unitaire"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: bill.bill_items.map(function (i) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: i.label
              }), /*#__PURE__*/_jsx("td", {
                children: i.quantity
              }), /*#__PURE__*/_jsx("td", {
                children: i.price
              })]
            }, i.id);
          })
        })]
      }), /*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx("b", {
          children: "Montant Payé (GNF) " + settlement.amount.toString().toLocaleString('Fr')
        })
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("div", {
        children: "Reste à Payer (GNF) " + (bill.total_amount - (bill.paid_amount + parseInt(settlement.amount))).toLocaleString('Fr')
      }), /*#__PURE__*/_jsx("div", {
        style: {
          textAlign: "center"
        },
        children: bill && /*#__PURE__*/_jsx(QRCode, {
          type: "svg",
          value: Common.baseUrl + "#/checkreceipt/" + bill.id.toString()
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), Common.businessAccount != 'undefined' && Common.businessAccount != null && /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsxs("b", {
          children: ["Adresse: ", Common.businessAccount.address, " - Tel: ", Common.businessAccount.mobile]
        })
      })]
    })
  });
};
export default OrderReceipt;